import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';

export interface DialogData { 
  message: string;  
  form: UntypedFormGroup;
}
@Component({
  selector: 'app-info-lettrage',
  templateUrl: './info-lettrage.component.html',
  styleUrls: ['./info-lettrage.component.scss']
})
export class InfoLettrageComponent implements OnInit { 
  message: string; 
  form: UntypedFormGroup;

  constructor(public dialog: MatDialog, 
    public router: Router,
    public dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }

  ngOnInit(): void {
    this.message = this.data.message;
    this.form = this.data.form;
  }

  onModalCancel(): void {
    this.dialogRef.close(false);
  }
  close(event): void {
    if (event == true)
      this.dialogRef.close(false);
  }

}
